
const m = window.require("discourse/components/color-palette-preview");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
